<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style lang="sass">
@import '/assets/style/app.scss'   
</style> 
